'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var ComboBoxBase = require('../common/ComboBoxBase');
var styleHelper = require('../../helper/styleHelper');
var linkHelper = require('../common/LinkHelper');
var util = require('../../helper/util');
var appTypes = require('../../types/appTypes');

/*
 @Author : mengxiaojiang
 @CreateDate : 2016-3-29
 @Descript : 下拉列表框组件
 */
var CompositeComboBox = React.createClass({

  getListControl: function() {
    if(!this.props.items) {
      return null;
    }
    var listControl = this.props.items[2];
    for(var i=0;i<this.props.items.length;i++) {
      if(this.props.items[i].controlTypeID === 'List') {
        listControl = this.props.items[i];
        break;
      }
    }
    return listControl;
  },

  parseText: function () {
    var items = [];

    var listControl = this.getListControl();
    var arr = [];
    if(listControl) {
      arr = util.Text.delimitToParagraphs(styleHelper.getText(listControl).trim());
    }
    var haveAction = false;
    var actionDatas = null;
    var i;

    if(listControl && listControl.interactiveData && listControl.links) {
      haveAction = true;
      actionDatas = linkHelper.parseComInteractive(listControl);
    }

    for (i = 0; i < arr.length; i++) {
      var text = util.Text.convertSpaceToNbsp(arr[i]);
      var linkStyle = 'no-link';
      if(haveAction) {
        linkStyle = this.checkLinkStyle(actionDatas[i]);
      }
      items.push({text: text, linkStyle: linkStyle});
    }
    return items;
  },

  checkLinkStyle: function(actionData) {
    if(!actionData) {
      return '';
    }
    this.haveAction = actionData.link !== undefined || actionData.entry !== undefined || actionData.externalURL !== undefined;;
    this.isLinkAction = actionData.link !== undefined || actionData.externalURL !== undefined;
    var linkAreaClass = 'no-link';
    if (this.haveAction) {
      if (this.isLinkAction) {
        linkAreaClass = 'page-link';
      } else {
        linkAreaClass = 'interactive-link';
      }
    }
    return linkAreaClass;
  },

  render: function () {
    if(!this.getListControl()) {
      return (<div />);
    }
    var textItems = this.parseText();
    var fun = undefined;
    if(this.props.events) {
      fun = this.props.events.triggerSelectExpand;
    }

    var props = {
      items: textItems,
      borderColor: this.props.borderColor,
      borderVisible: this.props.borderVisible,
      color: this.props.textColor,
      backgroundColor: this.props.color,
      fontSize: this.props.textSize,
      fontFamily: this.props.textFontFamily || decodeURIComponent(this.props.font.family),
      selectedIndex: this.getListControl().selectedIndex,
      listControl: this.getListControl(),
      width: styleHelper.getWidth(this.props),
      height: styleHelper.getHeight(this.props),
      canInput: this.props.canInput,
      onItemClick: this.onItemClick,
      triggerSelectExpand: fun
    };

    if (this.props.textStyles) {
      props.fontWeight = this.props.textStyles.fontWeight;
      props.fontStyle = this.props.textStyles.fontStyle;
      props.textDecoration = this.props.textStyles.textDecoration;
    }
    return (
      <ComboBoxBase ref="combobox" {...props}/>
    );
  },
  onItemClick: function (e, index) {
    var props = this.getListControl();
    var action = this.getAction(index);
    var selfClick = this.props.events.doSelfClick;
    selfClick(e, props, action, index);
  },

  getAction: function(index) {
    var props = this.getListControl();
    var link = props.links ? props.links.link[index] : {};
    var entry = props.interactiveData ? props.interactiveData.entry[index] : {};
    var action = appTypes.ActionResponseType.NONE;
    if(props.hasOwnProperty('externalURL') && props.externalURL !== ''){
      action = appTypes.ActionResponseType.OUTER;
    }else if(link.targetPageID !== '' && link.linkType === 'ltPageLink'){
      action = appTypes.ActionResponseType.LINK;
    }else if(entry.events && entry.events){
      action = appTypes.ActionResponseType.INTERACTIVE;
    }
    return action;
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this._onClick);
  },

  _onClick: function() {
    $(ReactDOM.findDOMNode(this).children[0]).trigger('toggleExpand');
  },

  onResize: function (e) {
    $(ReactDOM.findDOMNode(this.refs.combobox)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT);
  }

});

module.exports = CompositeComboBox;



// WEBPACK FOOTER //
// ./src/views/Components/CompositeComboBox.jsx